/**
 * Detect SOAP-note generation failures vs transcription / validation errors.
 * Used by live stop (HTTP) and upload auto-SOAP (websocket job) paths.
 */

function collectFailureText(payload) {
  if (payload == null) return "";
  if (typeof payload === "string") return payload;
  if (typeof payload !== "object") return String(payload);

  const parts = [
    payload.error,
    payload.message,
    payload.body?.message,
    payload.data?.message,
    payload.body?.data?.message,
    payload.code,
    payload.body?.data?.code,
    payload.data?.code,
  ];
  return parts.filter(Boolean).join(" ");
}

export function isSoapGenerationFailure(payload) {
  if (payload && typeof payload === "object") {
    if (payload.soapGenerationFailed === true) return true;
    const code =
      payload.code ||
      payload.body?.data?.code ||
      payload.data?.code ||
      payload.response?.data?.body?.data?.code;
    if (code === "SOAP_GENERATION_FAILED") return true;
  }

  const text = collectFailureText(payload);
  if (!text) return false;
  return (
    /SOAP generation failed/i.test(text) ||
    /couldn't finish the SOAP note/i.test(text) ||
    /could not be generated/i.test(text)
  );
}

export const SOAP_GENERATION_FAILED_TITLE = "SOAP Note could not be generated";

export const SOAP_GENERATION_FAILED_BODY =
  "We encountered a technical issue while generating your SOAP Note. Please try again.";

export const SOAP_GENERATION_FAILED_AGAIN_BODY =
  "We encountered another technical issue while generating your SOAP Note. Please try again.";
